import { NavItem } from "./nav-item/nav-item";

export const navItems: NavItem[] = [
  {
    displayName: "Dashboard",
    shortDescription: "side_menu.dashboard_short",
    Description: "side_menu.dashboard_desc",
    tags: [
      "overview",
      "metrics",
      "home",
      "dashboard",
      "resumen",
      "métricas",
      "inicio",
      "tablero",
    ],
    iconName: "home",
    route: "/dashboard",
  },

  {
    displayName: "Management",
    iconName: "briefcase",
    children: [
      {
        displayName: "Stores",
        shortDescription: "side_menu.stores_short",
        Description: "side_menu.stores_desc",
        tags: [
          "store",
          "location",
          "management",
          "tienda",
          "ubicación",
          "gestión",
        ],
        iconName: "shopping-cart",
        route: "/store/stores",
      },

      {
        displayName: "Cases Management",
        shortDescription: "side_menu.cases_short",
        Description: "side_menu.cases_desc",
        tags: [
          "cases",
          "tracking",
          "management",
          "casos",
          "seguimiento",
          "gestión",
        ],
        iconName: "checklist",
        route: "/store/cases",
      },
      {
        displayName: "Claims Management",
        shortDescription: "side_menu.claims_short",
        Description: "side_menu.claims_desc",
        tags: [
          "claims",
          "disputes",
          "refunds",
          "management",
          "reclamos",
          "disputas",
          "reembolsos",
          "gestión",
        ],
        iconName: "box-multiple",
        route: "/store/claims",
      },
      {
        displayName: "COGS Management",
        shortDescription: "side_menu.cogs_short",
        Description: "side_menu.cogs_desc",
        tags: [
          "cogs",
          "cost",
          "goods",
          "costo",
          "bienes",
          "mercancía",
          "management",
          "gestión",
        ],
        iconName: "calculator",
        route: "/store/cogs",
      },
    ],
  },

  {
    displayName: "Reports",
    iconName: "chart-bar",
    children: [
      {
        displayName: "Cases Report",
        shortDescription: "side_menu.cases_report_short",
        Description: "side_menu.cases_report_desc",
        tags: [
          "cases",
          "analysis",
          "trends",
          "casos",
          "análisis",
          "tendencias",
        ],
        iconName: "chart-line",
        route: "/report/cases",
      },
      {
        displayName: "Claims Report",
        shortDescription: "side_menu.claims_report_short",
        Description: "side_menu.claims_report_desc",
        tags: [
          "claims",
          "analysis",
          "statistics",
          "reclamos",
          "análisis",
          "estadísticas",
        ],
        iconName: "chart-area",
        route: "/report/claims",
      },
      {
        displayName: "Reimbursements",
        shortDescription: "side_menu.reimbursements_short",
        Description: "side_menu.reimbursements_desc",
        tags: [
          "reimbursement",
          "payment",
          "refund",
          "reembolso",
          "pago",
          "devolución",
        ],
        iconName: "chart-area",
        route: "/report/reimbursements",
      },
      // Temporarily disabled — inbound/outbound report not released yet.
      // {
      //   displayName: "Inbound/Outbound",
      //   shortDescription: "side_menu.inbound_outbound_short",
      //   Description: "side_menu.inbound_outbound_desc",
      //   tags: [
      //     "inbound",
      //     "outbound",
      //     "logistics",
      //     "entrada",
      //     "salida",
      //     "logística",
      //   ],
      //   iconName: "chart-area",
      //   route: "/report/inbound-outbound",
      // },
    ],
  },

  {
    displayName: "Billing",
    iconName: "credit-card",
    children: [
      {
        displayName: "Billing Overview",
        shortDescription: "side_menu.billing_overview_short",
        Description: "side_menu.billing_overview_desc",
        tags: [
          "billing",
          "payment",
          "invoices",
          "facturación",
          "pago",
          "facturas",
        ],
        iconName: "credit-card",
        route: "/billing",
      },
      {
        displayName: "Usage Overview",
        shortDescription: "side_menu.usage_overview_short",
        Description: "side_menu.usage_overview_desc",
        tags: [
          "billing",
          "usage",
          "tier",
          "claims",
          "potential cases",
          "casos potenciales",
          "facturación",
          "uso",
          "nivel",
          "reclamos",
        ],
        iconName: "chart-pie",
        route: "/usage-overview",
      },
    ],
  },
  {
    displayName: "helpCenter",
    iconName: "book-2",
    children: [
      {
        displayName: "FAQs",
        shortDescription: "side_menu.faqs_short",
        Description: "side_menu.faqs_desc",
        tags: ["help", "questions", "support", "ayuda", "preguntas", "soporte"],
        iconName: "help",
        route: "/help/faqs",
      },
      {
        displayName: "Knowledge Base",
        shortDescription: "side_menu.knowledge_base_short",
        Description: "side_menu.knowledge_base_desc",
        tags: [
          "help",
          "documentation",
          "guides",
          "knowledge",
          "ayuda",
          "documentación",
          "guías",
        ],
        iconName: "school",
        route: "/help/knowledge-base",
        queryParams: {
          returnUrl: "/dashboard",
          returnLabelKey: "knowledge_base.return.dashboard",
        },
      },
    ],
  },
  // {
  //   displayName: "Guides",
  //   shortDescription: "side_menu.guides_short",
  //   Description: "side_menu.guides_desc",
  //   tags: [
  //     "tutorials",
  //     "documentation",
  //     "learning",
  //     "tutoriales",
  //     "documentación",
  //     "aprendizaje",
  //   ],
  //   iconName: "note",
  //   route: "/help/guides",
  // },

  {
    navCap: "Legal",
  },
  {
    displayName: "Policies & Agreements",
    iconName: "gavel",
    children: [
      {
        displayName: "Privacy Policy",
        shortDescription: "side_menu.privacy_policy_short",
        Description: "side_menu.privacy_policy_desc",
        tags: ["privacy", "policy", "data", "privacidad", "política", "datos"],
        iconName: "shield-check",
        route: "/legal/privacy-policy",
      },
      {
        displayName: "EULA",
        shortDescription: "side_menu.eula_short",
        Description: "side_menu.eula_desc",
        tags: ["eula", "license", "agreement", "licencia", "acuerdo"],
        iconName: "file-text",
        route: "/legal/eula",
      },
    ],
  },

  // {
  //   displayName: "Contact Us",
  //   shortDescription: "side_menu.contact_short",
  //   Description: "side_menu.contact_desc",
  //   tags: ["support", "email", "contact", "soporte", "correo", "contacto"],
  //   iconName: "mail",
  // },
];

/** Routes searchable via Ctrl+K but not shown in the sidebar */
export const searchOnlyNavItems: NavItem[] = [
  {
    displayName: "Profile",
    shortDescription: "side_menu.profile_short",
    Description: "side_menu.profile_desc",
    tags: [
      "profile",
      "account",
      "user",
      "settings",
      "my account",
      "perfil",
      "cuenta",
      "usuario",
      "configuración",
      "mi cuenta",
    ],
    iconName: "user",
    route: "/profile",
  },
];
